export const getCurrentDate = state => state.date.date;
